/**
 * Image URL Utilities
 * Generates placeholder image URLs for different entities
 */

// Get agency image URL
export const getAgencyImage = (agencyId, agencyName) => {
  // Using placeholder service with agency-specific images
  const imageMap = {
    '1': 'https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?w=800&h=600&fit=crop&auto=format', // NASA - Rocket launch
    '2': 'https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=800&h=600&fit=crop&auto=format', // SpaceX
    '3': 'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=800&h=600&fit=crop&auto=format', // Roscosmos
    '4': 'https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?w=800&h=600&fit=crop&auto=format', // ESA
    '5': 'https://images.unsplash.com/photo-1615789591457-74a63395c990?w=800&h=600&fit=crop&auto=format'  // ISRO
  };
  return imageMap[agencyId] || `https://via.placeholder.com/400x300/1a1a2e/e94560?text=${encodeURIComponent(agencyName)}`;
};

// Get rocket image URL
export const getRocketImage = (rocketId, rocketName) => {
  const imageMap = {
    '1': 'https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?w=400&h=500&fit=crop', // Falcon 9
    '2': 'https://images.unsplash.com/photo-1541185933-ef5d8ed016c2?w=400&h=500&fit=crop', // Falcon Heavy
    '3': 'https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=400&h=500&fit=crop', // SLS
    '4': 'https://images.unsplash.com/photo-1614728423163-2c66ae886c6a?w=400&h=500&fit=crop', // Soyuz
    '5': 'https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?w=400&h=500&fit=crop'  // Ariane
  };
  return imageMap[rocketId] || `https://via.placeholder.com/400x500/1a1a2e/e94560?text=${encodeURIComponent(rocketName)}`;
};

// Get scientist image URL
export const getScientistImage = (scientistId, scientistName) => {
  const imageMap = {
    '1': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=400&fit=crop', // Katherine Johnson
    '2': 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=300&h=400&fit=crop', // Elon Musk
    '3': 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=400&fit=crop', // Wernher von Braun
    '4': 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300&h=400&fit=crop', // Sergey Korolev
    '5': 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=400&fit=crop'  // Vikram Sarabhai
  };
  return imageMap[scientistId] || `https://via.placeholder.com/300x400/1a1a2e/e94560?text=${encodeURIComponent(scientistName.split(' ')[0])}`;
};

// Get satellite image URL
export const getSatelliteImage = (satelliteId, satelliteName) => {
  const imageMap = {
    '1': 'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=400&h=300&fit=crop', // Hubble
    '2': 'https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?w=400&h=300&fit=crop', // JWST
    '3': 'https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=400&h=300&fit=crop', // Starlink
    '4': 'https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?w=400&h=300&fit=crop', // ISS
    '5': 'https://images.unsplash.com/photo-1614728423163-2c66ae886c6a?w=400&h=300&fit=crop'  // GPS
  };
  return imageMap[satelliteId] || `https://via.placeholder.com/400x300/1a1a2e/e94560?text=${encodeURIComponent(satelliteName)}`;
};

// Get article image URL
export const getArticleImage = (articleId, title) => {
  const imageMap = {
    '1': 'https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?w=600&h=400&fit=crop',
    '2': 'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=600&h=400&fit=crop',
    '3': 'https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=600&h=400&fit=crop'
  };
  return imageMap[articleId] || `https://via.placeholder.com/600x400/1a1a2e/e94560?text=${encodeURIComponent(title.substring(0, 30))}`;
};

// Get news image URL
export const getNewsImage = (newsId, headline) => {
  const imageMap = {
    '1': 'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=600&h=400&fit=crop',
    '2': 'https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?w=600&h=400&fit=crop',
    '3': 'https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?w=600&h=400&fit=crop'
  };
  return imageMap[newsId] || `https://via.placeholder.com/600x400/1a1a2e/e94560?text=${encodeURIComponent(headline.substring(0, 30))}`;
};

// Get book image URL
export const getBookImage = (bookId, title) => {
  const imageMap = {
    '1': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=400&fit=crop',
    '2': 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=300&h=400&fit=crop',
    '3': 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=300&h=400&fit=crop',
    '4': 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=300&h=400&fit=crop',
    '5': 'https://images.unsplash.com/photo-1589998059171-988d887df646?w=300&h=400&fit=crop'
  };
  return imageMap[bookId] || `https://via.placeholder.com/300x400/1a1a2e/e94560?text=${encodeURIComponent(title.substring(0, 20))}`;
};
